import { BaseService } from "./baseService";
import httpRequest from "./index";

export class TransportOrderService extends BaseService<unknown, unknown, unknown, unknown> {
    /**
     * 常用货物
     * */
    public async topThreeGoods(): Promise<string[]> {
        const { data } = await this.service.put(`${this.path}/ship/top-three/goods`);
        return data;
    }
}

export const transportOrderService = new TransportOrderService("/transport/order", httpRequest);
